import { NextSeo } from 'next-seo';
import dynamic from 'next/dynamic';
import Head from 'next/head';
import { useEffect, useRef, useState } from 'react';
import MediaQuery from 'react-responsive';
// import Link from 'next/link';
import { FaEye, FaRegCalendarAlt, FaUserEdit } from 'src/components/icon';
import CardH from 'src/components/cards/card-h';
import CardV from 'src/components/cards/card-v';
import { APP_IMG, APP_URL, IS_NO_ROBOT_INDEX, IS_SHOW_COOKIE, NEXT_PUBLIC_SPEED_KEYPOINT, NEXT_PUBLIC_URL_SOUND, NEXT_PUBLIC_WEB_NAME_SOUND, SHOW_COMMEMORATE } from 'src/constants';
import { IMAGE_DEFAULT, WEB_DESC, WEB_KEYWORD, WEB_LOGO, WEB_NAME, WEB_TITLE, WEB_URL } from 'src/constants/layout';
// import WidgetSocialShare from 'src/components/widgets/widget-social-share';

import isEmpty from 'lodash/isEmpty';
import { useRouter } from 'next/router';
import Script from 'next/script';
import StickyBox from 'react-sticky-box';
import { KEY_ADS_POSITION } from 'src/components/ads/dynamic-ads';
import { getAffiliate, getFeatureImage } from 'src/utils/contents';
import { setContents } from 'src/utils/contents/set-contents';
import { getCountviews } from 'src/utils/countview';
import { isShouldFetch } from 'src/utils/detect-scrolling';
import { useDesktop } from 'src/utils/device';
import { escapeChar, htmlToPlainText, isExistAds, timestamp, useDateUpdate, usePageViews } from 'src/utils/helper';
import styled from 'styled-components';
// import LineLink from 'src/components/lineLink';
import axios from 'axios';
import WidgetStickyContents from 'src/components/widgets/translates/widget-sticky-contents';
import { DATALAYER_TYPE, sendDataLayerGlobal } from 'src/utils/datalayer/send-datalayer';

// const WidgetCookie = dynamic(import('src/components/widgets/widget-cookie'), { ssr: false });
const Carousels = dynamic(import('src/components/carousels'), { ssr: false });
const LineLink = dynamic(import('src/components/lineLink'));
const WidgetSocialShare = dynamic(import('src/components/widgets/widget-social-share'));
const DynamicAds = dynamic(import('src/components/ads/dynamic-ads'));
const AdsNative = dynamic(import('src/components/ads/ads-native'), { ssr: false });

const ReadFullPicture = ({ article, lastNews, related, lastContents = [], solrRelated, dataAffiliate, lineContent, ads, dataAdsNative, agent }) => {
  const router = useRouter();
  // const eventDataLayer = {
  //   key: KEY_EVENT.TRACK_EVENT,
  //   event: KEY_EVENT.CARD_CONTENT
  // };
  // console.log({ router });
  const isDesktop = useDesktop();
  const [isTranslate, setIsTranslate] = useState(false);
  const [isKeyPoint, setIsKeyPoint] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [selectLang, setSelectLang] = useState('TH');
  const [newsArticle, setNewsArticle] = useState({ ...article });
  useEffect(() => {
    // console.log('NEXT_PUBLIC_SPEED_KEYPOINT :', NEXT_PUBLIC_SPEED_KEYPOINT);
    if (!NEXT_PUBLIC_SPEED_KEYPOINT) {
      return; // ออกจาก useEffect ถ้าไม่มีค่า speed
    }
    setIsKeyPoint(true);
    const keypointContent = document.getElementById('keypoint-content');
    // console.log('keypointContent :', keypointContent);
    while (keypointContent?.firstChild) {
      keypointContent?.removeChild(keypointContent?.firstChild);
    }
    if (isKeyPoint === true && !isEmpty(article?.key_point)) {
      const element = document.getElementById('scrollto');
      element?.scrollIntoView({ behavior: 'smooth', block: 'center' });

      const div = document.createElement('div');
      div.innerHTML = article?.key_point || '';

      const strongElements = div.getElementsByTagName('strong');
      for (let i = 0; i < strongElements.length; i++) {
        strongElements[i].style.fontWeight = 'bold';
      }

      const speed = Number(NEXT_PUBLIC_SPEED_KEYPOINT) ?? 50;

      let txt = article?.key_point;
      let i = 0;

      txt = htmlToPlainText(txt?.replace(/<\/?[^>]+(>|$)/g, match => (match === '<li>' ? '_' : match === '<p>' ? '#' : '')));

      let ul = document.createElement('ul');
      let li = document.createElement('li');
      let divP = document.createElement('div');
      let currentMode = 'paragraph';

      const intervalId = setInterval(() => {
        if (i < txt.length) {
          const char = txt.charAt(i);

          if (char === '#') {
            // console.log('#2');

            // เพิ่ม p เก่าเข้า DOM ในตำแหน่งปัจจุบัน
            if (divP && divP.innerHTML.trim() !== '') {
              keypointContent?.appendChild(divP);
            }

            // สร้าง p ใหม่
            divP = document.createElement('p');
            currentMode = 'paragraph';

            i++;
          } else if (char === '_') {
            // console.log('#1');

            // เพิ่ม p ปัจจุบันก่อน (ถ้าเปลี่ยนจาก paragraph เป็น list)
            if (currentMode === 'paragraph' && divP && divP.innerHTML.trim() !== '') {
              keypointContent?.appendChild(divP);
              divP = null;
            }

            // สร้าง ul ใหม่เฉพาะเมื่อยังไม่มี หรือเพิ่งออกจาก paragraph mode
            if (currentMode !== 'list') {
              ul = document.createElement('ul');
              keypointContent?.appendChild(ul);
            }

            // สร้าง li ใหม่เสมอ
            li = document.createElement('li');
            ul.appendChild(li);
            currentMode = 'list';

            i++;
          } else {
            // console.log('#3');

            if (currentMode === 'list' && li) {
              li.innerHTML += char;
            } else if (currentMode === 'paragraph' && divP) {
              divP.innerHTML += char;

              // เพิ่ม p เข้า DOM ครั้งแรกที่มีข้อความ
              if (divP.innerHTML.length === 1 && !divP.parentNode) {
                keypointContent?.appendChild(divP);
              }
            }

            i++;
          }
        } else {
          // เมื่อจบ loop
          if (divP && divP.innerHTML.trim() !== '' && !divP.parentNode) {
            keypointContent?.appendChild(divP);
          }

          clearInterval(intervalId);
        }
      }, speed);

      return () => clearInterval(intervalId);
    }
  }, [isKeyPoint]);

  const handleTranslate = async newLanguage => {
    try {
      setSelectLang(newLanguage);
      setIsLoading(true);
      setIsTranslate(!isTranslate);
      setIsKeyPoint(false);
      if (NEXT_PUBLIC_URL_SOUND !== undefined || !isEmpty(_article?.id)) {
        const uriToken = `${NEXT_PUBLIC_URL_SOUND}/create`;
        const getToken = await axios
          .post(
            uriToken,
            {
              app: 'default'
            },
            {
              headers: {
                'Content-Type': 'application/json',
                'User-Agents': `NationSpeech/1.0 ${agent}`
              }
            }
          )
          .catch(error => {
            console.error(error);
          });

        // console.log({ getToken });
        if (getToken?.data?.data?.token !== undefined) {
          const uriEn = `${NEXT_PUBLIC_URL_SOUND}/translates/${_article?.id}/${newLanguage}`;
          // console.log('uriEn', uriEn);

          const translate = await axios
            .post(
              uriEn,
              {
                data: {
                  id: _article?.id,
                  site: NEXT_PUBLIC_WEB_NAME_SOUND,
                  language: newLanguage
                }
              },
              {
                headers: {
                  'Content-Type': 'application/json',
                  'User-Agents': `NationSpeech/1.0 ${agent}`,
                  accessToken: getToken?.data?.data?.token,
                  accessTimeStamp: getToken?.data?.data?.timestamp
                }
              }
            )
            .catch(error => {
              console.error(error);
            });
          await new Promise(resolve => setTimeout(resolve, 500));
          setNewsArticle({
            ...article,
            ...translate?.data?.data
          });
        }
      }
    } catch (error) {
      setIsLoading(true);
      console.log(error, 'Error Translate ');
    } finally {
      setIsLoading(false);
    }
  };
  const _article = {
    ...article,
    ...newsArticle,
    description: article?.meta?.description || WEB_DESC,
    keyword: article?.meta?.keyword || WEB_KEYWORD,
    image_url: article?.meta?.og_social_image || IMAGE_DEFAULT
  };

  const [updateCountView, setUpdateCountView] = useState(0);
  const dateUpdate = useDateUpdate(_article?.published_at, true);
  const baseUrlCategory = `${_article?.canonical}`;

  const [sectionTrack, setSectionTrack] = useState('section-1');
  /* ----------------------------------- SEO ---------------------------------- */
  const articleTitleSeo = escapeChar(_article?.title) || WEB_TITLE;
  const articleDescriptionSeo = escapeChar(_article?.description) || WEB_DESC;
  /* -------------------------------------------------------------------------- */

  useEffect(() => {
    /* ------------------------------ GET COUNTVIEW ----------------------------- */
    (async () => {
      try {
        const _countviews = await getCountviews(_article?.id);
        if (_countviews) {
          setUpdateCountView(_countviews + Number(_article?.pageviews));
        }
      } catch (error) {
        setUpdateCountView(0);
      }
    })();
    setContents();
    return () => {
      window.onbeforeunload = null;
    };
  }, []);

  // ACCEPT COOKIE ********************************
  const handleScrollAdsPostArticle = () => {
    const sectionEl = document.getElementById('cookie');
    const sticky = document.querySelector('.sticky-cookie');
    const cookies = document.querySelector('.displayC');
    if (sectionEl !== null) {
      if (sectionEl.offsetTop < document.documentElement.scrollTop + 400) {
        if (sticky) {
          sticky.style.display = 'block';
        }
        if (cookies && IS_SHOW_COOKIE === 'true') {
          cookies.style.display = 'none';
        }
      } else {
        if (sticky) {
          sticky.style.display = 'none';
        }
        if (cookies && IS_SHOW_COOKIE === 'true') {
          cookies.style.display = 'unset';
        }
      }
    }
  };

  useEffect(() => {
    document.addEventListener('scroll', handleScrollAdsPostArticle);
    return () => document.removeEventListener('scroll', handleScrollAdsPostArticle);
  });

  /* -------------------------------- DATALAYER ------------------------------- */

  const nextSectionIndexRef = useRef(0);
  const sectionsVisibleRef = useRef([]);
  const sectionRef = useRef(null);
  const footerRef = useRef(false);
  const loadMoreArticles = () => {
    try {
      if (nextSectionIndexRef?.current < related.length) {
        if (isShouldFetch()) {
          const currentIndex = nextSectionIndexRef.current;
          const section = related[currentIndex];

          nextSectionIndexRef.current = currentIndex + 1;
          sectionsVisibleRef.current = [...sectionsVisibleRef.current, section];

          setTimeout(() => {
            loadMoreArticles();
          }, 1000);
        } else {
          document.addEventListener('scroll', handleScroll);
        }
      }
    } catch (err) {
      console.error(`${timestamp()}==========> INDEX ERROR : ${nextSectionIndexRef.current}`, err);
    }
  };

  const handleParagraphOne = async () => {
    const sectionEl = await document.getElementById('paragraph-1');

    if (sectionEl) {
      if (sectionEl.offsetTop < document.documentElement.scrollTop) {
        sectionRef.current = 'paragraph-1';

        document.removeEventListener('scroll', handleParagraphOne);
        await sendDataLayerGlobal({
          type: DATALAYER_TYPE.TRACK_SCROLL,
          router: router?.pathname,
          section: 'scroll',
          data: {
            title: router.asPath,
            heading: 'paragraph-1'
          }
        });
      }
    }
  };

  const handleParagraphTwo = async () => {
    const sectionEl = await document.getElementById('paragraph-2');

    if (sectionEl) {
      if (sectionEl.offsetTop < document.documentElement.scrollTop) {
        sectionRef.current = 'paragraph-2';
        document.removeEventListener('scroll', handleParagraphTwo);
        await sendDataLayerGlobal({
          type: DATALAYER_TYPE.TRACK_SCROLL,
          router: router?.pathname,
          section: 'scroll',
          data: {
            title: router.asPath,
            heading: 'paragraph-2'
          }
        });
      }
    }
  };

  const handleParagraphThree = async () => {
    const sectionEl = await document.getElementById('paragraph-3');
    if (sectionEl) {
      if (sectionEl.offsetTop < document.documentElement.scrollTop) {
        sectionRef.current = 'paragraph-3';
        document.removeEventListener('scroll', handleParagraphThree);
        await sendDataLayerGlobal({
          type: DATALAYER_TYPE.TRACK_SCROLL,
          router: router?.pathname,
          section: 'scroll',
          data: {
            title: router.asPath,
            heading: 'paragraph-3'
          }
        });
      }
    }
  };

  const handleScrollToReadComplete = async () => {
    try {
      const sectionEl = await document.getElementById('add-line');
      if (sectionEl !== null) {
        if (sectionEl.offsetTop < document.documentElement.scrollTop) {
          // console.log(sectionEl);
          // console.log(localStorage.getItem('_t'), isNaN(localStorage.getItem('_t')));
          sectionRef.current = 'add-line';
          const _t = localStorage.getItem('_t');
          if (!isNaN(_t)) {
            const counter = parseInt(_t);
            const toArray = num => num && [...`${num}`].map(elem => parseInt(elem));
            const _a = toArray(counter)[toArray(counter).length - 1] === 0 ? 0 : 1;
            const _b = counter - 1;
            const start = Math.floor((_a === 0 ? _b : counter) / 10) * 10;
            const end = Math.ceil(counter / 10) * 10;
            const first = start === 0 ? 1 : start + 1;
            const second = end === 0 ? 10 : end;
            const timer = `${first}-${second}`;

            document.removeEventListener('scroll', handleScrollToReadComplete);
            await sendDataLayerGlobal({
              type: DATALAYER_TYPE.TRACK_READTIME,
              router: router?.pathname,
              section: 'scroll',
              data: {
                title: router.asPath,
                heading: 'read-complete',
                time: timer
              }
            });
            await localStorage.removeItem('_t');
          } else {
            document.removeEventListener('scroll', handleScrollToReadComplete);
            await sendDataLayerGlobal({
              type: DATALAYER_TYPE.TRACK_READTIME,
              router: router?.pathname,
              section: 'scroll',
              data: {
                title: router.asPath,
                heading: 'read-complete',
                time: '1-10'
              }
            });
            await localStorage.removeItem('_t');
          }
        }
      }
    } catch (err) {
      console.error(`${timestamp()} ==========> handleScrollToReadComplete ERROR`);
    } finally {
      footerRef.current = true;
    }
  };

  const handleScrollToSectionAds = async () => {
    const sectionEl = await document.getElementById('section-ads');
    if (sectionEl !== null) {
      if (sectionEl.offsetTop < document.documentElement.scrollTop) {
        sectionRef.current = 'section-ads';
        document.removeEventListener('scroll', handleScrollToSectionAds);
        await sendDataLayerGlobal({
          type: DATALAYER_TYPE.TRACK_SCROLL,
          router: router?.pathname,
          section: 'scroll',
          data: {
            title: router.asPath,
            heading: 'section-ads'
          }
        });
        footerRef.current = true;
      }
    }
  };
  const handleScrollToSectionFooter = async () => {
    const sectionEl = await document.getElementById('footer-wrapper');
    if (footerRef.current) {
      if (sectionEl?.offsetTop < document.documentElement.scrollTop + 500) {
        document.removeEventListener('scroll', handleScrollToSectionFooter);
        await sendDataLayerGlobal({
          type: DATALAYER_TYPE.TRACK_SCROLL,
          router: router?.pathname,
          section: 'scroll',
          data: {
            title: router.asPath,
            heading: 'footer-wrapper'
          }
        });
      }
    }
  };

  useEffect(() => {
    try {
      localStorage.setItem('_t', '0');
      const increment = () => {
        const count = localStorage.getItem('_t');
        const time = parseInt(count);
        localStorage.setItem('_t', time + 1);
      };
      setInterval(increment, 1000);
    } catch (err) {
      // PROVIDE FEEDBACK TO THE USER
      console.log('Error: Please enable website cookies. ' + err);
    }
  }, []);

  const handleScroll = () => {
    if (isShouldFetch()) {
      document.removeEventListener('scroll', handleScroll);
      loadMoreArticles();
    }
  };

  useEffect(() => {
    document.addEventListener('scroll', handleScroll);
    return () => document.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    document.addEventListener('scroll', handleParagraphOne);
    return () => document.removeEventListener('scroll', handleParagraphOne);
  }, []);

  useEffect(() => {
    document.addEventListener('scroll', handleParagraphTwo);
    return () => document.removeEventListener('scroll', handleParagraphTwo);
  }, []);

  useEffect(() => {
    document.addEventListener('scroll', handleParagraphThree);
    return () => document.removeEventListener('scroll', handleParagraphThree);
  }, []);

  useEffect(() => {
    document.addEventListener('scroll', handleScrollToReadComplete);
    return () => document.removeEventListener('scroll', handleScrollToReadComplete);
  }, []);

  useEffect(() => {
    document.addEventListener('scroll', handleScrollToSectionAds);
    return () => document.removeEventListener('scroll', handleScrollToSectionAds);
  }, []);

  useEffect(() => {
    document.addEventListener('scroll', handleScrollToSectionFooter);
    return () => document.removeEventListener('scroll', handleScrollToSectionFooter);
  }, []);
  // console.log('article :', article);
  /* -------------------------------------------------------------------------- */
  return (
    <>
      {/* -------------------------------- NEXT_SEO -------------------------------- */}
      <NextSeo
        noindex={IS_NO_ROBOT_INDEX}
        nofollow={IS_NO_ROBOT_INDEX}
        title={_article?.title ? `${_article?.title} - ขอบสนาม` : WEB_TITLE}
        description={_article?.description || WEB_DESC}
        robotsProps={{
          maxImagePreview: 'large',
          maxSnippet: -1,
          maxVideoPreview: -1
        }}
        openGraph={{
          type: 'article',
          locale: 'th_TH',
          site_name: WEB_NAME,
          title: _article?.title ? `${_article?.title} - ขอบสนาม` : WEB_TITLE,
          description: _article?.description || WEB_DESC,
          url: baseUrlCategory,
          article: {
            publishedTime: _article?.published_at,
            modifiedTime: _article?.updated_at,
            expirationTime: null,
            section: _article?.section?.th,
            authors: [`${WEB_URL.FACEBOOK}`],
            tags: _article?.tags
          },
          images: [
            {
              url: _article?.image_url,
              width: '700',
              height: '395',
              alt: _article?.title ? `${_article?.title} - ขอบสนาม` : WEB_TITLE
            }
          ]
        }}
        additionalMetaTags={[
          {
            name: 'keywords',
            content: _article?.keyword || WEB_KEYWORD
          }
        ]}
      />
      {/* --------------------------------- HEADER --------------------------------- */}
      <Head>
        <link rel='canonical' href={baseUrlCategory} />
        <meta property='twitter:title' content={_article?.title ? `${_article?.title} - ขอบสนาม` : WEB_TITLE} />
        <meta property='twitter:description' content={_article?.description || WEB_DESC} />
        <meta property='twitter:image' content={_article?.image_url || IMAGE_DEFAULT} />

        {/* ------------------------------- Truehit -------------------------------- */}
        <script
          type='text/javascript'
          dangerouslySetInnerHTML={{
            __html: `
                    __th_page="${_article?.section?.en}";
                  `
          }}
        />

        {/* ---------------------------- SNIPPET : WebSite --------------------------- */}
        <script
          type='application/ld+json'
          dangerouslySetInnerHTML={{
            __html: `
                    {
                      "@context": "https://schema.org",
                      "@type": "WebSite",
                      "name": "${WEB_NAME}",
                      "url": "${WEB_URL.WEB}",
                      "description": "${articleDescriptionSeo}",
                      "sameAs": [
                        "${WEB_URL.FACEBOOK}",
                        "${WEB_URL.YOUTUBE}",
                        "${WEB_URL.INSTAGRAM}"
                      ],
                      "potentialAction": {
                        "@type": "SearchAction",
                        "target": "${WEB_URL.WEB}search?q={search_term_string}",
                        "query-input": "required name=search_term_string"
                      }
                    }
                  `
          }}
        />

        {/* ---------------------------- SNIPPET : WebPage --------------------------- */}
        <script
          type='application/ld+json'
          dangerouslySetInnerHTML={{
            __html: ` 
                    { 
                      "@context": "http://schema.org", 
                      "@type": "WebPage", 
                      "name": "${articleTitleSeo} - ขอบสนาม", 
                      "description": "${articleDescriptionSeo}", 
                      "publisher": { 
                        "@type": "ProfilePage", 
                        "name": "${WEB_NAME}" 
                      } 
                    } 
                  `
          }}
        />

        {/* ------------------------ SNIPPET : BreadcrumbList ------------------------ */}
        <script
          type='application/ld+json'
          dangerouslySetInnerHTML={{
            __html: ` 
                    { 
                      "@context": "http://schema.org", 
                      "@type": "BreadcrumbList", 
                      "itemListElement": [ 
                        { 
                          "@type": "ListItem", 
                          "position": 1, 
                          "name": "หน้าแรก", 
                          "item": "${APP_URL}" 
                        }, 
                        { 
                          "@type": "ListItem", 
                          "position": 2, 
                          "name": "${_article?.section?.th}", 
                          "item": "${APP_URL}/${_article?.section?.en}" 
                        }, 
                        { 
                          "@type": "ListItem", 
                          "position": 3, 
                          "name": "${articleTitleSeo} - ขอบสนาม", 
                          "item": "${_article?.canonical || `${APP_URL}${_article?.link}`}"  
                        } 
                      ] 
                    } 
                  `
          }}
        />

        {/* -------------------------- SNIPPET : NewsArticle ------------------------- */}
        <script
          type='application/ld+json'
          dangerouslySetInnerHTML={{
            __html: ` 
                    { 
                      "@context": "http://schema.org", 
                      "@type": "NewsArticle", 
                      "mainEntityOfPage": { 
                        "@type": "WebPage", 
                        "@id": "${_article?.canonical || `${APP_URL}${_article?.link}`}"  
                      }, 
                      "headline": "${articleTitleSeo} - ขอบสนาม", 
                      "alternativeHeadline": "${articleTitleSeo} - ขอบสนาม", 
                      "description": "${articleDescriptionSeo}", 
                      "image": "${APP_IMG}${_article?.image}", 
                      "datePublished": "${_article?.published_at}",
                      "dateModified": "${_article?.updated_at}",
                      "author": { 
                        "@type": "Thing", 
                        "name": "${_article.byline || WEB_NAME}",
                        "url": "${APP_URL}"
                      }, 
                      "publisher": { 
                        "@type": "Organization", 
                        "name": "${WEB_NAME}", 
                        "logo": { 
                          "@type": "ImageObject", 
                          "url": "${APP_IMG}/images/${WEB_LOGO}" 
                        } 
                      } 
                    } 
                  `
          }}
        />
        <link rel='preload' as='image' href={`${APP_IMG}${_article?.image}?x-image-process=style/XL`} fetchPriority='high' />
        {/* -------------------------------- ADS : Native ------------------------------- */}
        {/* <script async type='text/javascript' src='//code.th.giraff.io/data/widget-khobsanamcom.js' /> */}
        {/* <script async src='https://www.tiktok.com/embed.js' /> */}
      </Head>

      {/* ------------------------------ MAIN : START ------------------------------ */}
      <DetailWrapper style={{ filter: SHOW_COMMEMORATE === 'true' ? 'grayscale(0.7)' : '' }}>
        {/* --------------------------- Social embed script -------------------------- */}
        <Script src='//www.instagram.com/embed.js' strategy='lazyOnload' />
        <Script src='https://platform.twitter.com/widgets.js' strategy='lazyOnload' />
        {/* START BG-MAIN */}

        <div className='breadcrumb-area'>
          <div className='content-feature-image '>{getFeatureImage(_article)}</div>

          <div className='container'>
            <div className='breadcrumb-title'>
              <h1 className='category'>{_article?.title}</h1>

              <MediaQuery minWidth={769}>{_article?.blurb && <h2 className='content-blurb'>{_article.blurb}</h2>}</MediaQuery>

              <div className='post-info'>
                <ul className='dateUpdate --white'>
                  <li>
                    <FaRegCalendarAlt />
                    <span>{dateUpdate}</span>
                  </li>
                  <li>
                    <FaEye />
                    <span>{usePageViews(updateCountView)}</span>
                  </li>
                </ul>
                {article?.byline && (
                  <div className='byline  --white'>
                    <FaUserEdit /> <span> {article?.byline} </span>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* END BG-MAIN */}
        <div className='container'>
          {/* ----------------------------------- CONTENTS : Start ---------------------------------- */}
          <div className='article-area'>
            <div className='row mb-30'>
              <div className='col-12 col-lg-8 position-relative position-md-unset'>
                {/* ----------------------------- ADS : BILLBOARD ---------------------------- */}
                {_article.is_show_ads && (
                  <div className='overflow-hidden default-billboard '>{isExistAds(ads, KEY_ADS_POSITION.BILLBOARD) && <DynamicAds position={KEY_ADS_POSITION.BILLBOARD} data={ads} />}</div>
                )}
                <WidgetStickyContents className='block-sticky' isLoading={isLoading} article={article} handleTranslate={handleTranslate} selectLang={selectLang} />
                {!isEmpty(article?.key_point) && (
                  <div className='keypoint-wrapper'>
                    <HeadSeo
                      dangerouslySetInnerHTML={{
                        __html: `${article?.blurb || ''}`
                      }}
                    />
                    <div className='keypoint-header'>
                      <p>KEY</p>
                      <p>POINTS</p>
                    </div>
                    <div
                      id='keypoint-content'
                      className='keypoint-lists'
                      dangerouslySetInnerHTML={{
                        __html: _article.key_point ?? ''
                      }}
                    />
                  </div>
                )}
                <MediaQuery maxWidth={768}>{article?.blurb && <h2 className='content-blurb'>{_article.blurb}</h2>}</MediaQuery>
                <div id='contents' className='article-content'>
                  {/* ------------------------- CONTENTS I and ADS : INARTICLE 1 ------------------------- */}
                  {_article?.content_I && (
                    <div id='paragraph-1' className='default-inread'>
                      <div className='content-detail' dangerouslySetInnerHTML={{ __html: _article?.content_I }} />
                      {_article?.is_show_ads && getAffiliate(1, dataAffiliate)}
                    </div>
                  )}

                  {/* ------------------------- CONTENTS II and ADS : INARTICLE 2 ------------------------ */}
                  {_article?.content_II && (
                    <div id='paragraph-2' className='default-inread'>
                      {_article?.is_show_ads && isExistAds(ads, KEY_ADS_POSITION.INARTICLE_2) && <DynamicAds position={KEY_ADS_POSITION.INARTICLE_2} data={ads} />}
                      <div className='content-detail' dangerouslySetInnerHTML={{ __html: _article?.content_II }} />
                      {_article?.is_show_ads && getAffiliate(2, dataAffiliate)}
                    </div>
                  )}

                  {/* -------------------------- CONTENTS III and ADS : INARTICLE 3 ----------------------- */}
                  {_article?.content_III && (
                    <div id='paragraph-3' className='default-inread'>
                      {_article?.is_show_ads && isExistAds(ads, KEY_ADS_POSITION.INARTICLE_3) && <DynamicAds position={KEY_ADS_POSITION.INARTICLE_3} data={ads} />}
                      <div className='content-detail' dangerouslySetInnerHTML={{ __html: _article?.content_III }} />
                      {_article?.is_show_ads && getAffiliate(3, dataAffiliate)}
                    </div>
                  )}

                  {/* ----------------------------- ADS : INARTICLE - 2 ---------------------------- */}
                  {/* <MediaQuery maxWidth={768}>
                    <DynamicAds type={KEY_ADS_TYPE.INARTICLE} section='contents-mobile' adsName='inarticle-2' />
                  </MediaQuery> */}
                  {/* ------------------------------ Related ------------------------------ */}
                  <div className='d-block d-lg-none col-12 col-lg-12 block-readmore-content mt-5 cardh-read-page'>
                    {!isEmpty(related) && (
                      <div className='related-scroll'>
                        {/* <Carousels slideShow={2} vertical={true} autoplaySpeed={1500} > */}
                        {related.slice(0, 5).map(
                          (item, index) => (
                            // <div key={index} className='solr-card-h'>
                            <CardH
                              key={index}
                              data={item}
                              path={item.link}
                              //! DATALAYER
                              eventDataLayer={{
                                type: DATALAYER_TYPE.TRACK_POSITION,
                                router: router?.pathname,
                                section: 'ข่าวที่เกี่ยวข้อง',
                                position: 'ใต้:เนื้อหาที่-3',
                                data: {
                                  block: '1',
                                  title: item?.title,
                                  heading: 'ข่าวที่เกี่ยวข้อง',
                                  index: index + 1
                                }
                              }}
                            />
                          )
                          // {/* </div> */}
                        )}
                        {/* </Carousels> */}
                      </div>
                    )}
                  </div>
                  {_article?.is_show_ads && isExistAds(ads, KEY_ADS_POSITION.INARTICLE_1) && <DynamicAds position={KEY_ADS_POSITION.INARTICLE_1} data={ads} />}

                  {/* ---------------------------------- ADD LINE ------------------------------- */}
                  <LineLink lineContent={lineContent} />

                  {/* ------------------------------ lastContents tags: ขอบสนาม ------------------------------ */}
                  {!isEmpty(lastContents) && (
                    <div className='d-lg-block d-none ruwai-chiwa'>
                      <div className='heading-ruwai-chiwa'>
                        <h2>
                          {' '}
                          ขอบสนาม <span> รู้ใว้ใช่ว่า </span>
                        </h2>
                      </div>
                      <div className='row'>
                        {lastContents.slice(0, 4).map((item, index) => (
                          <div key={index} className='col-6 ruwai-chiwa-card-h'>
                            <CardH
                              excerpt={2}
                              showCountview={true}
                              showTime={true}
                              data={item}
                              path={item?.link}
                              //! DATALAYER
                              eventDataLayer={{
                                type: DATALAYER_TYPE.TRACK_POSITION,
                                router: router?.pathname,
                                section: 'ขอบสนาม รู้ใว้ใช่ว่า',
                                position: 'ใต้:เพื่มเพื่อน',
                                data: {
                                  block: '1',
                                  title: item?.title,
                                  heading: 'ขอบสนาม รู้ใว้ใช่ว่า',
                                  index: index + 1
                                }
                              }}
                            />
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                  {/* ------------------------------ READ_COMPLETE ------------------------ */}
                  <div id='read-complete' className='content-tags'>
                    {!isEmpty(_article?.tags) && <span>แท็กที่เกี่ยวข้อง</span>}
                    {!isEmpty(_article?.tags) &&
                      _article.tags.map((item, index) => (
                        <a
                          key={index}
                          title={item}
                          href={`/tags/${item}`}
                          //! DATALAYER
                          onClick={() =>
                            sendDataLayerGlobal({
                              type: DATALAYER_TYPE.TRACK_POSITION,
                              router: router?.pathname,
                              section: 'แท็กที่เกี่ยวข้อง',
                              position: isDesktop ? 'ใต้:ข่าวที่เกี่ยวข้อง' : 'ใต้:เพิ่มเพื่อน',
                              data: {
                                block: '1',
                                title: item,
                                heading: 'แท็กที่เกี่ยวข้อง',
                                index: index + 1
                              }
                            })
                          }
                        >
                          {item}
                        </a>
                      ))}
                    {/* ----------------------------- ADS : POSTARTICE ---------------------------- */}
                    {/* <div>
                      <MediaQuery maxWidth={768}>
                        <DynamicAds type={KEY_ADS_TYPE.POSTARTICE} section='contents-mobile' adsName='portarticle' />
                      </MediaQuery>
                    </div> */}

                    <div className='section-sharelink --mobile'>
                      <div className='mt-4'>
                        <WidgetSocialShare
                          articleLink={article?.link}
                          //! DATALAYER
                          eventDataLayer={{
                            type: DATALAYER_TYPE.TRACK_POSITION,
                            router: router?.pathname,
                            section: 'แชร์ข่าว',
                            position: 'ใต้:แท็กที่เกี่ยวข้อง',
                            data: {
                              block: '1',
                              heading: 'แชร์ข่าว'
                            }
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  {/* Start Read more ++ --------------------------------------------------------- */}
                  <div className='row d-lg-block d-none'>
                    {!isEmpty(related) && (
                      <Carousels slideShow={3} infinite={related.lenght > 3}>
                        {related?.map((blockItem, index) => (
                          <div className='card-v-carousels' key={index}>
                            <CardV
                              key={index}
                              data={blockItem}
                              path={blockItem.link}
                              //! DATALAYER
                              eventDataLayer={{
                                type: DATALAYER_TYPE.TRACK_POSITION,
                                router: router?.pathname,
                                section: 'ข่าวที่เกี่ยวข้อง',
                                position: 'ใต้:แชร์ข่าว',
                                data: {
                                  block: '1',
                                  title: blockItem?.title,
                                  heading: 'ข่าวที่เกี่ยวข้อง',
                                  carousel: index + 1
                                }
                              }}
                            />
                          </div>
                        ))}
                      </Carousels>
                    )}
                  </div>
                  {/* ------------------------------ solrRelated ------------------------------ */}
                  {!isEmpty(solrRelated) && (
                    <div className='d-lg-none d-block mobile-solr-item mt-3'>
                      <Carousels slideShow={1}>
                        {solrRelated.slice(0, 5).map((item, index) => (
                          <div className='card-v-solr-mobile' key={index}>
                            <CardV
                              data={item}
                              path={item.link}
                              external={true}
                              //! DATALAYER
                              eventDataLayer={{
                                type: DATALAYER_TYPE.TRACK_POSITION,
                                router: router?.pathname,
                                section: 'ข่าวที่น่าสนใจ',
                                position: isDesktop ? 'ใต้:ข่าวที่เกี่ยวข้อง' : 'ใต้:แชร์ข่าว',
                                data: {
                                  block: '1',
                                  title: item?.title,
                                  heading: 'ข่าวที่น่าสนใจ',
                                  carousel: index + 1
                                }
                              }}
                            />
                          </div>
                        ))}
                      </Carousels>
                    </div>
                  )}
                  {/* --------------------------- ADS : Native (Infinities) ----------------------------------- */}
                  {article?.is_show_ads && <AdsNative data={dataAdsNative} isShowAds={article?.is_show_ads} />}
                </div>
                {/* ------------------------ Cookie ---------------------- */}
                <div id='cookie' className='displayUnset'>
                  <div className='ads-sticky-overflow'>
                    {/* ----------------------------- ADS : POSTARTICE -------------------------- */}
                    <MediaQuery minWidth={481}>
                      {_article?.is_show_ads && isExistAds(ads, KEY_ADS_POSITION.POSTARTICLE) && <DynamicAds position={KEY_ADS_POSITION.POSTARTICLE} data={ads} />}
                    </MediaQuery>

                    {/* {IS_SHOW_COOKIE === 'true' && (
                      <div className='displayC'>
                        {' '}
                        <WidgetCookie />{' '}
                      </div>
                    )} */}
                  </div>
                </div>
              </div>

              {/* ---------------------------- BLOCKSIDE : START --------------------------- */}
              <div className='col-12 col-lg-4 d-none d-lg-block position-relative'>
                <StickyBox offsetTop={170} offsetBottom={50}>
                  <div className='side-article'>
                    {/* ----------------------------- ADS : STICKY-1 -------------------------- */}
                    {_article.is_show_ads && isExistAds(ads, KEY_ADS_POSITION.STICKY_1) && (
                      <div className='default-sticky'>
                        <DynamicAds position={KEY_ADS_POSITION.STICKY_1} data={ads} />{' '}
                      </div>
                    )}

                    {!isEmpty(solrRelated) && (
                      <div className='mb-30'>
                        <div className='heading'>
                          <h2>ข่าวที่น่าสนใจ</h2>
                        </div>
                        <div className='row'>
                          {solrRelated.slice(0, 5).map((item, index) => (
                            <div key={index} className='col-12 solr-card-h'>
                              <CardH
                                data={item}
                                path={item?.link}
                                external={true}
                                //! DATALAYER
                                eventDataLayer={{
                                  type: DATALAYER_TYPE.TRACK_POSITION,
                                  router: router?.pathname,
                                  section: 'ข่าวที่น่าสนใจ',
                                  position: 'ใต้:รูปข่าว',
                                  data: {
                                    block: '2',
                                    title: item?.title,
                                    heading: 'ข่าวที่น่าสนใจ',
                                    index: index + 1
                                  }
                                }}
                              />
                            </div>
                          ))}
                        </div>
                      </div>
                    )}

                    {/* ----------------------------- ADS : STICKY-2 -------------------------- */}
                    <div className='default-sticky'>{_article.is_show_ads && isExistAds(ads, KEY_ADS_POSITION.STICKY_2) && <DynamicAds position={KEY_ADS_POSITION.STICKY_2} data={ads} />}</div>

                    {lastNews?.length > 0 && (
                      <div className='mb-30'>
                        <div className='heading'>
                          <h2>ข่าวล่าสุด</h2>
                        </div>
                        <div className='row'>
                          {lastNews.slice(0, 2).map((item, index) => (
                            <div className='col-12 mt-15 mb-15 card-v' key={index}>
                              <CardV
                                data={item}
                                path={item?.link}
                                byline={true}
                                //! DATALAYER
                                eventDataLayer={{
                                  type: DATALAYER_TYPE.TRACK_POSITION,
                                  router: router?.pathname,
                                  section: 'ข่าวล่าสุด',
                                  position: 'ใต้:ข่าวที่น่าสนใจ',
                                  data: {
                                    block: '2',
                                    title: item?.title,
                                    heading: 'ข่าวล่าสุด',
                                    index: index + 1
                                  }
                                }}
                              />
                            </div>
                          ))}
                        </div>
                      </div>
                    )}

                    {/* ----------------------------- ADS : STICKY-3 -------------------------- */}
                    {_article.is_show_ads && isExistAds(ads, KEY_ADS_POSITION.STICKY_3) && (
                      <div className='default-sticky'>
                        <DynamicAds position={KEY_ADS_POSITION.STICKY_3} data={ads} />
                      </div>
                    )}
                  </div>
                </StickyBox>
              </div>
              {/* ---------------------------- BLOCKSIDE : END --------------------------- */}
            </div>
          </div>
        </div>
        {/* ----------------------------------- CONTENTS : End ---------------------------------- */}
      </DetailWrapper>
      {/* ------------------------------ MAIN : END ------------------------------ */}
    </>
  );
};
const HeadSeo = styled.h2`
  position: absolute;
  visibility: hidden;
  overflow: hidden;
`;
const DetailWrapper = styled.div`
  margin-top: -25px;
  @media (min-width: 767px) {
    .default-billboard {
      min-height: unset;
      margin-bottom: 30px;

      /* max-height: 100px; */
      .ads-billboard {
        min-height: 90px;
        margin: 0px auto;
        padding: 15px 0px;
      }
    }
  }
  .ads-inarticle-1 {
    padding: 15px 0px;
    @media (max-width: 767px) {
      min-height: 280px;
    }
  }
  .default-sticky {
    background: rgb(245, 245, 245);
    padding: 10px;
    min-height: 300px;
  }
  .keypoint-wrapper {
    display: flex;
    border-top: 7px solid #06fe55;
    padding: 30px 0;
    margin-top: 10px;
    border-bottom: 1px dashed #06fe55;

    .keypoint-header {
      /* margin-top: 8px; */
      p {
        color: #06fe55;
        font-size: 25px;
        font-weight: bolder;
        letter-spacing: 0.4px;
        line-height: 1.05;
        text-transform: uppercase;
      }
    }
    .keypoint-lists {
      overflow: hidden;
      // display: flex;
      align-items: center;
    }
    ul {
      padding-left: 30px;
      @media (max-width: 767px) {
        padding-left: 15px;
        padding-top: 15px;
      }
      li {
        display: flex;
        align-items: flex-start;

        ::marker {
          font-size: 24px;
          line-height: 0;
          color: #06fe55;
        }
        list-style-type: disc;
        display: list-item;
        margin-left: 1.5rem;
        line-height: 1.65;
        font-size: 20px;
        a {
          letter-spacing: 0.2px;
          font-display: swap;
        }
      }
    }
    p {
      margin-left: 1.5rem;
      line-height: 1.65;
      font-size: 20px;
      padding: 5px 0;
    }
    @media (max-width: 767px) {
      display: block;

      padding: 20px 0;
      margin-bottom: 30px;
      .keypoint-header {
        display: flex;
        p {
          font-size: 22px;
        }
        margin-top: 0px;
      }
      ul {
        li {
          font-size: 16px;
        }
      }
    }
  }
  .related-scroll {
    // padding: 0 17px;
    margin: auto;
    width: 80%;
    max-width: 100%;
    min-height: 280px !important;
    height: 280px !important;
    overflow-y: scroll !important;
    display: none;
    @media (max-width: 768px) {
      margin-top: 30px;
      display: block;
    }
    @media (max-width: 480px) {
      width: 90%;
    }
  }
  /* twitter */
  .twitter-tweet {
    margin: auto;
  }
  .card-v-carousels {
    padding: 8px;
  }
  .card-v-solr-mobile {
    padding: 15px;
  }
  .block-readmore-content {
    max-width: 90%;
    width: 100%;
    margin: auto;
    margin-top: 10px;
    .post-info {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 10px 0;
      .meta {
        display: flex;
        .byline {
          margin-right: 10px;
        }
        p,
        span,
        svg {
          color: rgba(0, 0, 0, 0.6);
          font-size: 14px;
        }
      }
    }
  }

  .post-info {
    .byline {
      @media (max-width: 475px) {
        padding-bottom: 5px;
      }
    }
  }
  .article-read-more:not(:nth-child(1)) {
    margin-top: 45px;
  }
  .article-read-more:not(:last-child) {
    margin-bottom: 0px;
  }
  .article-read-more {
    border-radius: 3px;
    background-color: #fff;
    padding: 15px 15px 20px 15px;
    margin-bottom: 20px;
    min-height: 300px;
    max-height: 900px;
    position: relative;
    overflow: hidden;
    .button-readmore {
      position: absolute;
      bottom: 40px;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: 2;
      background-color: #00ff57;
      border: 2px solid #00ff57;
      border-radius: 2px;
      padding: 5px 20px;
      cursor: pointer;
      transition: all 0.5s;
      &:hover {
        background-color: #000;
        border: 2px solid #00ff57;
        &:hover {
          a {
            color: #00ff57;
          }
        }
      }
      a {
        transition: all 0.5s;
        color: black;
        font-size: 16px;
        font-weight: 500;
      }
    }
    .fade-content-readmore {
      position: absolute;
      height: 60%;
      width: 100%;
      background-image: linear-gradient(to top, #fffffffb 3%, #ffffff00);
      bottom: 0;
      z-index: 1;
    }
    .breadcrumb-area-readmore {
      .breadcrumb-title-readmore {
        h3 {
          margin: 0;
          font-size: 28px;
        }
        @media (max-width: 768px) {
          h3 {
            font-size: 24px;
          }
        }
      }
    }

    .content-feature-image-readmore {
      .resolution-image {
        border-radius: 3px;
      }
      .embed-responsive {
        iframe {
          width: 100%;
          height: 400px;
          @media (max-width: 500px) {
            height: 220px;
          }
        }
      }
    }
    .content-blurb {
      font-size: 18px;
    }
  }
  .breadcrumb-area {
    position: relative;
    background-color: #000;
    .breadcrumb-title {
      background-color: rgba(0, 0, 0, 0.7);
      position: absolute;
      bottom: 0;
      padding: 20px 40px 40px 40px;
      margin-bottom: 30px;
      max-width: 60%;
      @media (max-width: 1024px) {
        max-width: 100%;
        padding: 10px 20px 20px 20px;
        margin-bottom: 0;
        left: 0;
        width: 100%;
      }
      @media (max-width: 480px) {
        background: linear-gradient(180deg, rgba(0, 0, 0, 0.5) 10%, rgba(0, 0, 0, 0.9) 70%);
        .category {
          margin: 0px 0 5px 0;
        }
        padding: 10px;
        left: 0;
      }

      h1 {
        color: white;
        @media (max-width: 1024px) {
          font-size: 24px;
        }
        @media (max-width: 480px) {
          margin: 10px 0;
          font-size: 22px;
        }
      }
      h2 {
        color: rgba(240, 240, 240, 0.8);
        font-weight: normal;
        @media (max-width: 1024px) {
          font-size: 16px;
        }
      }
      ul.dateUpdate {
        list-style-type: none;
        padding-left: 0;
        display: flex;
        align-items: center;
        margin: 0px;
        li {
          color: #cecece;
          svg {
            margin-top: 2px;
          }
          svg,
          span {
            vertical-align: middle;
            @media (max-width: 768px) {
              font-size: 14px;
            }
            @media (max-width: 480px) {
              font-size: 12px;
            }
          }
          span {
            padding-left: 10px;
          }
        }
        li + li {
          padding-left: 10px;
        }
      }
      .byline {
        text-transform: uppercase;
        /* color: #cecece; */
        /* svg {
            margin-top: 2px;
          } */
        span {
          padding-left: 3px;
        }
        @media (max-width: 768px) {
          font-size: 14px;
        }
        @media (max-width: 480px) {
          font-size: 12px;
          svg {
            margin-bottom: 2px;
          }
          span {
            font-size: 12px;
          }
        }
      }
      .post-info {
        margin-bottom: 0px;
      }
    }
  }
  .post-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 8px 0px 18px 0px;
    .dateUpdate {
      display: flex;
      list-style: none;
      padding: 0;
      margin: 0;
      &.--white {
        li {
          svg,
          span {
            color: rgba(214, 214, 214, 0.7);
            @media (max-width: 768px) {
              color: rgba(225, 225, 225, 0.8);
            }
          }
        }
      }
      li {
        svg,
        span {
          vertical-align: middle;
          color: rgba(0, 2, 28, 0.75);
          font-size: 14px;

          @media (max-width: 768px) {
            font-size: 12px;
          }
        }
        svg {
          margin-bottom: 2px;
        }
        span {
          padding-left: 10px;
        }
      }
      li + li {
        padding-left: 10px;
      }
    }
    .byline {
      text-transform: uppercase;
      &.--white {
        svg,
        span {
          color: rgba(214, 214, 214, 0.7);
          @media (max-width: 768px) {
            color: rgba(225, 225, 225, 0.8);
          }
        }
      }

      svg,
      span {
        vertical-align: middle;
        color: rgba(0, 2, 28, 0.75);
        font-size: 14px;
      }
      @media (max-width: 768px) {
        span {
          font-size: 12px;
        }
      }
    }
    @media (max-width: 475px) {
      margin: 0;
      /* margin: 8px 0px 8px 0px; */
      display: block;
      .byline {
        padding-top: 5px;
      }
    }
  }

  .side-article {
    .card-v {
      padding: 0px;
    }

    .heading {
      margin-left: -3px;
    }
  }
  .content-blurb {
    color: rgba(0, 0, 28, 0.95);
    font-size: 22px;
    line-height: 1.75;
    @media (max-width: 768px) {
      border-bottom: 1px solid rgba(244, 244, 244);
      padding-bottom: 10px;
      font-size: 20px;
      margin: 15px 0 10px 0;
    }
  }
  .container {
    display: flex;
  }
  .article-area {
    padding-top: 15px;
    width: 95%;
    @media (max-width: 768px) {
      width: 100%;
    }
    .accept-cookie {
      @media (min-width: 769px) {
        margin-bottom: 30px !important;
      }
    }
  }

  .content-detail {
    font-family: 'Sarabun', sans-serif;
    line-height: 1.75;
    font-size: 16px;
    font-weight: 300;
    letter-spacing: 0.25px;
    word-break: break-word;
    font-display: swap;
    h2 {
      font-size: 18px;
      display: block;
      margin: 10px 0;
      font-size: 18px;
      font-weight: 500;
      color: #000;
      width: 95%;
      line-height: 1.8;
      border-left: 8px solid rgba(0, 170, 44);
      background: linear-gradient(90deg, #f8f8f8 85%, white 100%);
      padding: 15px 15px 15px 35px;
      border-radius: 4px;
    }

    pre {
      white-space: break-spaces;
    }

    strong,
    span {
      font-weight: 700;
    }
    img {
      max-width: 100%;
      margin: 20px auto;
      height: auto !important;
      width: 100% !important;
    }
    p {
      a {
        color: #00b83d;
        font-weight: 700;
      }
    }
    a {
      &:hover {
        color: #008f30;
      }
    }
    iframe {
      position: relative !important;
      margin: 10px auto !important;
      max-width: 100%;
      display: flex;
      min-height: 400px;
      @media (max-width: 475px) {
        min-height: unset;
      }
    }

    ul {
      li {
        list-style-type: circle;
        display: list-item;
        a {
          font-family: 'Prompt', sans-serif;
          letter-spacing: 0.2px;
          font-display: swap;
        }
      }
    }

    blockquote {
      @media (max-width: 480px) {
        margin: 0;
      }
    }

    blockquote > p,
    blockquote > span,
    blockquote > strong {
      background: rgb(232 255 232 / 60%);
      padding: 30px;
      margin: 10px;
      border-left: 3px solid #0f0;
      @media (max-width: 768px) {
        padding: 15px 20px;
      }
    }

    picture {
      display: inline-block;
      span {
        width: 100%;
        display: block;
        position: relative;
        text-align: center;
        font-size: 13px;
        font-weight: 300;
        line-height: 1.6;
        color: rgb(117, 117, 117);
        padding: 10px;
        margin: -5px auto 15px 0px;
      }
    }
    .image-caption {
      font-weight: 400;
      font-size: 13px !important;
      font-style: italic;
      letter-spacing: 0.25px;
    }
    .affaliate-image {
      width: 80% !important;
    }

    // iframe dailymotion
    div[style='position:relative;padding-bottom:56.25%;height:0;overflow:hidden;'] > iframe {
      display: block;
      position: relative !important;
      margin: 20px auto !important;
      max-width: 100% !important;
      height: 480px;
      @media (max-width: 767px) {
        height: 190px !important;
      }
    }
    div[style='position:relative;padding-bottom:56.25%;height:0;overflow:hidden;'] {
      height: 480px !important;
      @media (max-width: 767px) {
        height: 200px !important;
      }
    }
    // iframe dailymotion end
  }

  //START TAG หน้าอ่าน ********************************
  .content-tags {
    font-size: 14px;
    margin-top: 20px;
    margin-bottom: 20px;
    span {
      border-radius: 2px;
      padding: 7px 10px;
      background-color: #000;
      color: #ffffff;
      margin-right: 5px;
    }
    a {
      display: inline-flex;
      border: 1px solid rgba(1, 11, 43, 0.95);
      border-radius: 2px;
      padding: 4px 8px;
      color: rgba(1, 11, 43, 0.95);
      margin: 5px 5px 0 0;
      @media (min-width: 475px) {
        margin: 10px 5px 0 0;
      }
      transition: all 0.5s ease-out;
      &:hover {
        background-color: #000000;
        border: 1px solid #00ff57;
        /* a { */
        color: #00ff57 !important;
        /* } */
      }
    }
  }
  //END TAG หน้าอ่าน ********************************

  /* start share */
  .section-sharelink {
    .article-share {
      .social {
        display: flex;
        list-style-type: none;
        align-items: center;
        padding: 0;
        @media (max-width: 768px) {
          justify-content: center;
        }
        svg {
          circle {
            transition: all 0.5s;
          }
          &:hover {
            circle {
              fill: rgb(0, 0, 0);
            }
            path {
              fill: #00ff57;
            }
          }
        }
        li:not(:first-child) {
          padding-left: 5px;
        }
      }
    }
  }
  /* end share */

  .ruwai-chiwa {
    .heading-ruwai-chiwa {
      display: flex;
      align-items: center;
      width: 100%;
      margin-top: 30px;
      border-bottom: 1px solid;
      h2,
      span {
        font-family: 'Sarabun', sans-serif;
        padding-bottom: 5px;
        font-size: 20px !important;
        line-height: 1.75;
        margin: 0;
        color: rgba(0, 170, 44);
      }
      span {
        font-weight: 900;
        margin-left: -3px;
        color: rgba(0, 2, 28, 9.5);
      }
    }
    .related-card-h:nth-child(5),
    .related-card-h:nth-child(6) {
      .card-h {
        border: none;
      }
    }
    .card-h {
      box-shadow: unset;
      border-radius: unset;
      h3 {
        padding: 0px !important;
        font-size: 16px !important;
        font-family: 'Sarabun', sans-serif;
        line-height: 1.75;
        font-weight: 400;
      }
    }
    .ruwai-chiwa-card-h {
      .img-scale-animate {
        border-radius: 3px;
        border: unset !important;
        box-shadow: unset !important;
      }
      .resolution-image {
        position: relative !important;
        @media (max-width: 1024px) and (min-width: 767px) {
        }
      }
    }
  }
  .solr-card-h {
    padding-right: 15px;
  }
  .solr-card-h,
  .related-card-h {
    padding-left: 3px;
    .resolution-image {
      @media (max-width: 1024px) and (min-width: 767px) {
        position: absolute !important;
      }
    }
  }
  .card-h-readmore {
    .readmore {
      background-color: #fff;
      border-radius: 3px;
    }
  }
  // accept cookie
  .displayUnset {
    display: unset;
    padding: 0;
    position: sticky;
    bottom: 0;
  }
`;

export default ReadFullPicture;
